export default __webpack_public_path__ + "static/media/Captain's Gauntlets of the Ascending Kingdom.9f1d0113.jpg";